// heyshape Gallery Arrow Navigation & Dot Handling
document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('product-gallery');
  
  galleries.forEach(gallery => {
    const mediaCarousel = gallery.querySelector('media-carousel');
    const leftArrow = gallery.querySelector('.gallery-arrow--left');
    const rightArrow = gallery.querySelector('.gallery-arrow--right');
    const dots = gallery.querySelectorAll('.page-dots--heyshape .tap-area--dot');
    
    if (!mediaCarousel) return;
    
    const scrollContainer = mediaCarousel.querySelector('[role="region"]') || mediaCarousel;
    const allItems = mediaCarousel.querySelectorAll('.product-gallery__media:not([hidden])');
    
    // Function to update arrow visibility
    const updateArrows = () => {
      if (!leftArrow || !rightArrow || allItems.length === 0) return;
      
      const scrollLeft = scrollContainer.scrollLeft;
      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      
      // Hide left arrow at start
      if (scrollLeft <= 10) {
        leftArrow.style.display = 'none';
      } else {
        leftArrow.style.display = 'flex';
      }
      
      // Hide right arrow at end
      if (scrollLeft >= maxScroll - 10) {
        rightArrow.style.display = 'none';
      } else {
        rightArrow.style.display = 'flex';
      }
    };
    
    // Initial arrow state
    updateArrows();
    
    // Update arrows on scroll
    scrollContainer.addEventListener('scroll', updateArrows);
    
    // Navigate left
    if (leftArrow) {
      leftArrow.addEventListener('click', function(e) {
        e.preventDefault();
        const itemWidth = allItems[0]?.offsetWidth || scrollContainer.offsetWidth;
        
        scrollContainer.scrollBy({
          left: -itemWidth,
          behavior: 'smooth'
        });
      });
    }
    
    // Navigate right
    if (rightArrow) {
      rightArrow.addEventListener('click', function(e) {
        e.preventDefault();
        const itemWidth = allItems[0]?.offsetWidth || scrollContainer.offsetWidth;
        
        scrollContainer.scrollBy({
          left: itemWidth,
          behavior: 'smooth'
        });
      });
    }
    
    // Dot navigation
    dots.forEach(dot => {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        const mediaPosition = parseInt(this.getAttribute('data-media-position') || this.getAttribute('data-index'));
        const targetMedia = mediaCarousel.querySelector(`[data-media-id][data-media-id*="${mediaPosition}"]`) || 
                           mediaCarousel.querySelector(`.product-gallery__media:nth-child(${mediaPosition})`);
        
        if (targetMedia) {
          targetMedia.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        }
      });
    });
  });
});

// Variant Sold Out State Handler
class VariantSoldOutHandler {
  constructor() {
    this.initVariantPickers();
  }

  initVariantPickers() {
    const variantPickers = document.querySelectorAll('variant-picker[data-variant-availability]');
    
    variantPickers.forEach(picker => {
      try {
        const variants = JSON.parse(picker.dataset.variantAvailability);
        this.setupPicker(picker, variants);
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    });
  }

  setupPicker(picker, variants) {
    const options = picker.querySelectorAll('fieldset.variant-picker__option');
    
    // Listen for changes on all option inputs
    options.forEach((optionFieldset, optionIndex) => {
      const inputs = optionFieldset.querySelectorAll('input[type="radio"]');
      
      inputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updateSoldOutStates(picker, variants);
        });
      });
    });

    // Initial state
    this.updateSoldOutStates(picker, variants);
  }

  updateSoldOutStates(picker, variants) {
    const options = picker.querySelectorAll('fieldset.variant-picker__option');
    const selectedValues = this.getSelectedValues(picker);
    
    options.forEach((optionFieldset, optionIndex) => {
      const optionPosition = optionIndex + 1;
      const swatches = optionFieldset.querySelectorAll('[data-option-value]');
      
      // Check if this is the first option (usually color)
      const isFirstOption = optionIndex === 0;
      
      swatches.forEach(swatch => {
        const input = swatch.querySelector('input') || 
                     picker.querySelector(`input[value="${swatch.textContent.trim()}"]`);
        
        if (!input) return;
        
        const optionValue = input.value;
        
        // For the first option (color), check if ANY variant with this color is available
        // For other options (size), check based on the selected color
        let isAvailable;
        
        if (isFirstOption) {
          // Color: available if ANY variant with this color is available (regardless of size)
          isAvailable = variants.some(variant => {
            return variant[`option${optionPosition}`] === optionValue && variant.available;
          });
        } else {
          // Size/other options: check availability based on currently selected options
          isAvailable = this.isOptionAvailable(
            variants,
            optionPosition,
            optionValue,
            selectedValues,
            optionIndex
          );
        }
        
        // Update sold out state
        if (isAvailable) {
          swatch.classList.remove('is-sold-out');
          input.disabled = false;
        } else {
          swatch.classList.add('is-sold-out');
          input.disabled = true;
        }
      });
    });
  }

  getSelectedValues(picker) {
    const selected = {};
    const inputs = picker.querySelectorAll('input[type="radio"]:checked');
    
    inputs.forEach(input => {
      const fieldset = input.closest('fieldset.variant-picker__option');
      const optionIndex = Array.from(picker.querySelectorAll('fieldset.variant-picker__option')).indexOf(fieldset);
      selected[`option${optionIndex + 1}`] = input.value;
    });
    
    return selected;
  }

  isOptionAvailable(variants, optionPosition, optionValue, selectedValues, currentOptionIndex) {
    // Find variants that match this option value
    const matchingVariants = variants.filter(variant => {
      const variantOptionValue = variant[`option${optionPosition}`];
      
      if (variantOptionValue !== optionValue) {
        return false;
      }
      
      // Check if it matches other selected options (except the current one we're checking)
      for (let i = 1; i <= 3; i++) {
        if (i === optionPosition) continue; // Skip current option
        
        const selectedValue = selectedValues[`option${i}`];
        if (selectedValue && variant[`option${i}`] !== selectedValue) {
          return false;
        }
      }
      
      return true;
    });
    
    // Return true if any matching variant is available
    return matchingVariants.some(variant => variant.available);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VariantSoldOutHandler();
  });
} else {
  new VariantSoldOutHandler();
}


